import { SanityClient } from "sanity";

export function calculateInputResult(
  calculationString?: string,
  dynamicNumber?: number,
): number | null {
  if (!calculationString) {
    return null;
  }

  const includesDynamicNumber = calculationString.includes("{{number}}");
  const _eval = (fn: string) => new Function("return " + fn)();

  try {
    if (includesDynamicNumber && dynamicNumber) {
      return _eval(
        calculationString.replace("{{number}}", dynamicNumber.toString()),
      );
    }

    return _eval(calculationString);
  } catch (e) {
    return null;
  }
}

export async function fetchDynamicNumber(
  dynamicNumberId: string,
  client: Pick<SanityClient, "fetch">,
): Promise<number | null> {
  return await client
    .fetch(
      `*[_type == "copyLibraryText" && _id == $id][0] {
      ...
    }`,
      {
        id: dynamicNumberId,
      },
    )
    .then((result) => {
      if (
        result?.type === "number" &&
        typeof result?.number?.value === "number"
      ) {
        return result.number.value;
      }
    })
    .catch(() => null);
}
